<template lang="html">
  <div class="title tac mw700 p1">
    <div class="mb1 fs2 amp" v-html="content.title" />
    <div v-for="(question, index) in content.questions" :key="index">
      <div class="amp mb1 italic" v-html="question.question" />
      <div class="mb1 tjc" v-html="question.answer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: Object
  }
};
</script>

<style lang="scss" scoped></style>
